import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import { useState } from "react";

export const InputField = (props) => {
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [location, setLocation] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState(props.defaultCategoryId || "");

  const submit = () => {
    if (!title || !desc || !eventDate) {
      alert("Please fill in all required fields (Name, Description, Date)");
    } else {
      props.addEvent(title, desc, eventDate, location, selectedCategoryId);
      // Reset form
      setTitle("");
      setDesc("");
      setEventDate("");
      setLocation("");
      if (!props.defaultCategoryId) {
        setSelectedCategoryId("");
      }
    }
  };

  return (
    <>
      <h4 className="text-2xl my-3 text-center ml-3 font-bold md:ml-0">Add New Event</h4>
      <Form>
        <Row className="flex flex-col">
          <Col className="flex items-center">
            <div id="labels">Event name</div>
            <Form.Control
              size="lg"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
              placeholder="Event Name"
              className="my-2 px-3"
            />
          </Col>
          <Col className="flex items-center">
            <div id="labels">Event Description</div>
            <Form.Control
              size="lg"
              value={desc}
              onChange={(e) => {
                setDesc(e.target.value);
              }}
              placeholder="Description"
              className="m-2"
            />
          </Col>
          
          <div className="md:flex">
            <Col className="flex items-center">
              <div id="labels">Event Date</div>
              <Form.Control
                size="lg"
                type="date"
                value={eventDate}
                onChange={(e) => {
                  setEventDate(e.target.value);
                }}
                placeholder="Event Date"
                className="m-3"
              />
            </Col>
            <Col className="flex items-center">
              <div id="labels">Location</div>
              <Form.Control
                size="lg"
                value={location}
                onChange={(e) => {
                  setLocation(e.target.value);
                }}
                placeholder="Event Location (optional)"
                className="m-3"
              />
            </Col>
          </div>
          
          {/* Category Selection - only show if not already set by route */}
          {!props.defaultCategoryId && props.categories && props.categories.length > 0 && (
            <Col className="flex items-center">
              <div id="labels">Category</div>
              <Form.Select
                size="lg"
                value={selectedCategoryId}
                onChange={(e) => {
                  setSelectedCategoryId(e.target.value);
                }}
                className="m-2"
              >
                <option value="">Select a category</option>
                {props.categories.map((category) => (
                  <option key={category.category_id} value={category.category_id}>
                    {category.name}
                  </option>
                ))}
              </Form.Select>
            </Col>
          )}
          
          {/* Show selected category if set by route */}
          {props.defaultCategoryId && props.categories && (
            <Col className="flex items-center">
              <div id="labels">Category</div>
              <Form.Control
                size="lg"
                value={props.categories.find(cat => cat.category_id === props.defaultCategoryId)?.name || "Category"}
                disabled
                className="m-2"
              />
            </Col>
          )}
        </Row>
        <Row>
          <Col>
            <div className="btn">
              <Button variant="primary" type="button" onClick={submit}>
                ADD
              </Button>{" "}
            </div>
          </Col>
        </Row>
      </Form>
    </>
  );
};
